export default __webpack_public_path__ + "static/media/reports-icon.b5e30580.svg";